import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { KapatmaProvider } from './context/KapatmaContext';
import { AlarmProvider } from './context/AlarmContext';
import { UyariProvider } from './context/UyariContext';
import { KasaProvider } from './context/KasaContext';
import { AuthProvider } from './context/AuthContext';
import { useAuth } from './context/AuthContext';
import Login from './pages/auth/Login';
import DemoSuresiDoldu from './pages/auth/DemoSuresiDoldu';
import Page401 from './pages/hata/Page401';
import Page403 from './pages/hata/Page403';
import Page404 from './pages/hata/Page404';
import Page500 from './pages/hata/Page500';
import DashboardLayout from './layouts/DashboardLayout';
import Dashboard from './pages/dashboard/Dashboard';
import RezervasyonListesi from './pages/rezervasyon/RezervasyonListesi';
import MisafirListesi from './pages/misafir/MisafirListesi';
import KBSIslemleri from './pages/kbs/KBSIslemleri';
import RoomRack from './pages/roomrack/RoomRack';
import BlokajCizelge from './pages/blokaj/BlokajCizelge';
import HousekeepingPage from './pages/housekeeping/HousekeepingPage';
import GelenRezervasyonlar from './pages/kanal/GelenRezervasyonlar';
import FiyatVeMüsaitlik from './pages/kanal/FiyatVeMüsaitlik';
import KanalAyarlar from './pages/kanal/KanalAyarlar';
import GunlukKasa from './pages/kasa/GunlukKasa';
import AylikKasa from './pages/kasa/AylikKasa';
import Bakiyeler from './pages/kasa/Bakiyeler';
import TaksitOdemeler from './pages/kasa/TaksitOdemeler';
import SmsGonder from './pages/sms/SmsGonder';
import SmsAyarlari from './pages/sms/SmsAyarlari';
import GelirListesi from './pages/gelir-gider/GelirListesi';
import GiderListesi from './pages/gelir-gider/GiderListesi';
import GidenFaturalar from './pages/efatura/GidenFaturalar';
import GelenFaturalar from './pages/efatura/GelenFaturalar';
import RaporlamaRezervasyon from './pages/raporlama/RaporlamaRezervasyon';
import GunlereGoreFiyat from './pages/raporlama/GunlereGoreFiyat';
import GunlukOrtalama from './pages/raporlama/GunlukOrtalama';
import Forecast from './pages/raporlama/Forecast';
import PersonelGider from './pages/raporlama/PersonelGider';
import HousekeepingKirli from './pages/raporlama/HousekeepingKirli';
import MisafirUlke from './pages/raporlama/MisafirUlke';
import GonderilmisEmailler from './pages/raporlama/GonderilmisEmailler';
import LogKayitlari from './pages/raporlama/LogKayitlari';
import AcenteFirma from './pages/tanimlar/AcenteFirma';
import Firmalar from './pages/tanimlar/Firmalar';
import PersonelBirimi from './pages/tanimlar/PersonelBirimi';
import PersonelTipleri from './pages/tanimlar/PersonelTipleri';
import Roller from './pages/tanimlar/Roller';
import StokUrun from './pages/tanimlar/StokUrun';
import WalkInAdisyon from './pages/adisyon/WalkInAdisyon';
import HavuzYonetimi from './pages/havuz/HavuzYonetimi';
import OdaTipleri from './pages/tanimlar/OdaTipleri';
import OdaGruplari from './pages/tanimlar/OdaGruplari';
import OdaTanimlari from './pages/tanimlar/OdaTanimlari';
import OdaFiyatlandirma from './pages/tanimlar/OdaFiyatlandirma';
import ParaBirimleri from './pages/tanimlar/ParaBirimleri';
import OdemeTipleri from './pages/tanimlar/OdemeTipleri';
import BankaTanimlari from './pages/tanimlar/BankaTanimlari';
import GelirGruplari from './pages/tanimlar/GelirGruplari';
import GiderGruplari from './pages/tanimlar/GiderGruplari';
import KonaklamaTurleri from './pages/tanimlar/KonaklamaTurleri';
import BukletTanimlari from './pages/tanimlar/BukletTanimlari';
import MisafirTipleri from './pages/tanimlar/MisafirTipleri';
import LaundryTanimlari from './pages/tanimlar/LaundryTanimlari';
import DolulukFiyatKurallari from './pages/tanimlar/DolulukFiyatKurallari';
import WebSiteAyarlari from './pages/website/WebSiteAyarlari';
import WebSiteSayfalar from './pages/website/WebSiteSayfalar';
import WebSiteSEO from './pages/website/WebSiteSEO';
import MisafirMesajlari from './pages/website/MisafirMesajlari';
import OtelYonetimi from './pages/ayarlar/OtelYonetimi';
import CokOtelOzet from './pages/ayarlar/CokOtelOzet';
import Bildirimler from './pages/bildirimler/Bildirimler';
import KampAmiriSayfa from './pages/kampamiri/KampAmiriSayfa';
import { isDemoRouteDisabled } from './config/demoMode';

// PrivateRoute burada tanımladık, ayrı dosya açmana gerek yok
function PrivateRoute({ children }) {
  const { personel, loading } = useAuth();
  if (loading) return null;
  if (!personel) return <Navigate to="/login" replace />;
  if (personel.firmaId) return <Navigate to="/kamp-amiri" replace />;
  return (
    <KasaProvider>
      <AlarmProvider>
        <UyariProvider>
          {children}
        </UyariProvider>
      </AlarmProvider>
    </KasaProvider>
  );
}

function KampAmiriRoute({ children }) {
  const { personel, loading } = useAuth();
  if (loading) return null;
  if (!personel) return <Navigate to="/login" replace />;
  if (!personel.firmaId) return <Navigate to="/" replace />;
  return children;
}

function YoneticiRoute({ children }) {
  const { personel, hasYetki, loading } = useAuth();
  if (loading) return null;
  if (!personel) return <Navigate to="/login" replace />;
  if (personel.tip !== 'Yönetici' && !hasYetki('ayarlar')) return <Navigate to="/403" replace />;
  return children;
}

function YetkiRoute({ children, yetki }) {
  const { personel, hasYetki, loading } = useAuth();
  if (loading) return null;
  if (!personel) return <Navigate to="/login" replace />;
  if (!hasYetki(yetki)) return <Navigate to="/403" replace />;
  return children;
}

function DemoBlockedRoute({ path, children }) {
  if (isDemoRouteDisabled(path)) return <Page404 />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <KapatmaProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/demo-suresi-doldu" element={<DemoSuresiDoldu />} />

            <Route path="/" element={
              <PrivateRoute>
                <DashboardLayout />
              </PrivateRoute>
            }>
              <Route index element={<Dashboard />} />
              <Route path="rezervasyon" element={<YetkiRoute yetki="rezervasyonGoruntule"><RezervasyonListesi /></YetkiRoute>} />
              <Route path="walk-in-adisyon" element={<YetkiRoute yetki="walkInAdisyon"><WalkInAdisyon /></YetkiRoute>} />
              <Route path="havuz" element={<YetkiRoute yetki="havuzYonet"><HavuzYonetimi /></YetkiRoute>} />
              <Route path="misafirler" element={<YetkiRoute yetki="misafirGoruntule"><MisafirListesi /></YetkiRoute>} />
              <Route path="kbs" element={<YetkiRoute yetki="kbsIslemleri"><KBSIslemleri /></YetkiRoute>} />
              <Route path="room-rack" element={<YetkiRoute yetki="rezervasyonGoruntule"><RoomRack /></YetkiRoute>} />
              <Route path="blokaj" element={<YetkiRoute yetki="rezervasyonGoruntule"><BlokajCizelge /></YetkiRoute>} />
              <Route path="housekeeping" element={<YetkiRoute yetki="housekeeping"><HousekeepingPage /></YetkiRoute>} />
              <Route path="kanal/rezervasyonlar" element={<YetkiRoute yetki="kanalYonetimi"><GelenRezervasyonlar /></YetkiRoute>} />
              <Route path="kanal/fiyat" element={<YetkiRoute yetki="kanalYonetimi"><FiyatVeMüsaitlik /></YetkiRoute>} />
              <Route path="kanal/ayarlar" element={<YetkiRoute yetki="kanalYonetimi"><KanalAyarlar /></YetkiRoute>} />
              <Route path="kasa/gunluk" element={<YetkiRoute yetki="gunlukKasaGoruntule"><GunlukKasa /></YetkiRoute>} />
              <Route path="kasa/aylik" element={<YetkiRoute yetki="genelKasaGoruntule"><AylikKasa /></YetkiRoute>} />
              <Route path="kasa/bakiyeler" element={<YetkiRoute yetki="bakiyeGoruntule"><Bakiyeler /></YetkiRoute>} />
              <Route path="kasa/taksit-odemeler" element={<YetkiRoute yetki="taksitGoruntule"><TaksitOdemeler /></YetkiRoute>} />
              <Route path="sms/gonder" element={<YetkiRoute yetki="smsListesi"><SmsGonder /></YetkiRoute>} />
              <Route path="sms/ayarlar" element={<YetkiRoute yetki="smsListesi"><SmsAyarlari /></YetkiRoute>} />
              <Route path="gelir-gider/gelir" element={<YetkiRoute yetki="muhasebeListesi"><GelirListesi /></YetkiRoute>} />
              <Route path="gelir-gider/gider" element={<YetkiRoute yetki="muhasebeListesi"><GiderListesi /></YetkiRoute>} />
              <Route path="efatura/giden" element={<DemoBlockedRoute path="/efatura/giden"><YetkiRoute yetki="efaturaGoruntule"><GidenFaturalar /></YetkiRoute></DemoBlockedRoute>} />
              <Route path="efatura/gelen" element={<DemoBlockedRoute path="/efatura/gelen"><YetkiRoute yetki="efaturaGoruntule"><GelenFaturalar /></YetkiRoute></DemoBlockedRoute>} />
              <Route path="raporlama/rezervasyon" element={<YetkiRoute yetki="raporRezervasyonlar"><RaporlamaRezervasyon /></YetkiRoute>} />
              <Route path="raporlama/fiyat" element={<YetkiRoute yetki="raporFinansal"><GunlereGoreFiyat /></YetkiRoute>} />
              <Route path="raporlama/gunluk-ortalama" element={<YetkiRoute yetki="raporDoluluk"><GunlukOrtalama /></YetkiRoute>} />
              <Route path="raporlama/forecast" element={<YetkiRoute yetki="raporDoluluk"><Forecast /></YetkiRoute>} />
              <Route path="raporlama/personel" element={<YetkiRoute yetki="raporPersonel"><PersonelGider /></YetkiRoute>} />
              <Route path="raporlama/housekeeping" element={<YetkiRoute yetki="housekeeping"><HousekeepingKirli /></YetkiRoute>} />
              <Route path="raporlama/ulkeler" element={<YetkiRoute yetki="misafirGoruntule"><MisafirUlke /></YetkiRoute>} />
              <Route path="raporlama/emailler" element={<YetkiRoute yetki="raporSistemLog"><GonderilmisEmailler /></YetkiRoute>} />
              <Route path="raporlama/log" element={<YetkiRoute yetki="raporSistemLog"><LogKayitlari /></YetkiRoute>} />
              <Route path="tanimlar/acente" element={<YetkiRoute yetki="tanimlarGenel"><AcenteFirma /></YetkiRoute>} />
              <Route path="tanimlar/firmalar" element={<YetkiRoute yetki="tanimlarGenel"><Firmalar /></YetkiRoute>} />
              <Route path="tanimlar/personel" element={<YetkiRoute yetki="tanimlarPersonel"><PersonelBirimi /></YetkiRoute>} />
              <Route path="tanimlar/personel-tipleri" element={<YetkiRoute yetki="tanimlarPersonel"><PersonelTipleri /></YetkiRoute>} />
              <Route path="tanimlar/roller" element={<YetkiRoute yetki="tanimlarPersonel"><Roller /></YetkiRoute>} />
              <Route path="tanimlar/stok" element={<YetkiRoute yetki="tanimlarGenel"><StokUrun /></YetkiRoute>} />
              <Route path="tanimlar/oda-tipleri" element={<YetkiRoute yetki="tanimlarOda"><OdaTipleri /></YetkiRoute>} />
              <Route path="tanimlar/oda-gruplari" element={<YetkiRoute yetki="tanimlarOda"><OdaGruplari /></YetkiRoute>} />
              <Route path="tanimlar/odalar" element={<YetkiRoute yetki="tanimlarOda"><OdaTanimlari /></YetkiRoute>} />
              <Route path="tanimlar/oda-fiyatlandirma" element={<YetkiRoute yetki="tanimlarOda"><OdaFiyatlandirma /></YetkiRoute>} />
              <Route path="tanimlar/para-birimleri" element={<YetkiRoute yetki="tanimlarFinansal"><ParaBirimleri /></YetkiRoute>} />
              <Route path="tanimlar/odeme-tipleri" element={<YetkiRoute yetki="tanimlarFinansal"><OdemeTipleri /></YetkiRoute>} />
              <Route path="tanimlar/banka-tanimlari" element={<YetkiRoute yetki="tanimlarFinansal"><BankaTanimlari /></YetkiRoute>} />
              <Route path="tanimlar/gelir-gruplari" element={<YetkiRoute yetki="tanimlarFinansal"><GelirGruplari /></YetkiRoute>} />
              <Route path="tanimlar/gider-gruplari" element={<YetkiRoute yetki="tanimlarFinansal"><GiderGruplari /></YetkiRoute>} />
              <Route path="tanimlar/konaklama-turleri" element={<YetkiRoute yetki="tanimlarGenel"><KonaklamaTurleri /></YetkiRoute>} />
              <Route path="tanimlar/buklet-tanimlari" element={<YetkiRoute yetki="tanimlarGenel"><BukletTanimlari /></YetkiRoute>} />
              <Route path="tanimlar/misafir-tipleri" element={<YetkiRoute yetki="tanimlarGenel"><MisafirTipleri /></YetkiRoute>} />
              <Route path="tanimlar/laundry" element={<YetkiRoute yetki="tanimlarGenel"><LaundryTanimlari /></YetkiRoute>} />
              <Route path="tanimlar/doluluk-fiyat" element={<YetkiRoute yetki="tanimlarOda"><DolulukFiyatKurallari /></YetkiRoute>} />
              <Route path="website/ayarlar" element={<YetkiRoute yetki="ayarlar"><WebSiteAyarlari /></YetkiRoute>} />
              <Route path="website/sayfalar" element={<YetkiRoute yetki="ayarlar"><WebSiteSayfalar /></YetkiRoute>} />
              <Route path="website/seo" element={<YetkiRoute yetki="ayarlar"><WebSiteSEO /></YetkiRoute>} />
              <Route path="website/mesajlar" element={<YetkiRoute yetki="ayarlar"><MisafirMesajlari /></YetkiRoute>} />
              <Route path="ayarlar/oteller" element={<YoneticiRoute><OtelYonetimi /></YoneticiRoute>} />
              <Route path="ayarlar/cok-otel-ozet" element={<YoneticiRoute><CokOtelOzet /></YoneticiRoute>} />
              <Route path="bildirimler" element={<Bildirimler />} />
            </Route>

            <Route path="/kamp-amiri" element={<KampAmiriRoute><KampAmiriSayfa /></KampAmiriRoute>} />

            <Route path="/401" element={<Page401 />} />
            <Route path="/403" element={<Page403 />} />
            <Route path="/500" element={<Page500 />} />
            <Route path="*" element={<Page404 />} />
          </Routes>
        </BrowserRouter>
      </KapatmaProvider>
    </AuthProvider>
  );
}

export default App;
